import styled from 'styled-components'

export const ShowFunctionWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 16px;

  & > div {
    flex: 1;
  }

  & > div {
    max-width: 50%;
  }

  & > div:last-child {
    max-width: 14%;
  }
`
